<template>
  <div v-if="display.value">
    <transition name="notification-transition">
      <div :class="['notification-wrapper', [type.value]]">
        <img
          class="err-img"
          v-if="type.value === 'err-msg'"
          src="../assets/images/error.svg"
          alt="error"
        />
        <div class="message" v-html="msgTxt.value"></div>
        <div class="close-btn" @click="closeNotification()">X</div>
      </div>
    </transition>
  </div>
</template>

<script>
import EventBus from '@/EventBus.js'
import NotificationEvent from '@/events/notificationEvents'

export default {
  name: 'Notification',
  data() {
    return {
      ...NotificationEvent.defaultState,
    }
  },
  methods: {
    closeNotification() {
      NotificationEvent.closeNotification()
    },
  },
  created() {
    EventBus.$on(NotificationEvent.eventName, (data) => {
      Object.keys(data).forEach(function (key) {
        if (this && this[key]) this[key].value = data[key].value
      })
    })
  },
}
</script>

<style lang="scss">
.notification-wrapper {
  min-height: 32px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  position: absolute;
  z-index: 100;
  font-size: 16px;
}

.info-msg {
  background-color: #3299cf;

  & div {
    color: #fff;
  }
}

.message {
  @media screen and (max-width: $mobile-resolution) {
    margin: 8px 0 8px 21px;
  }
  width: 83%;
}

.warning-msg {
  background: #ffdbd6;
}

.err-msg {
  width: 80%;
  margin-left: 10%;
  margin-top: 10px;
  border: 1px solid #d65c5c !important;
  border-radius: 10px;
  background-color: #fdecea;
  font-weight: bold;
  padding: 20px;
  position: relative;
}

.err-img {
  width: 20px;
  margin-right: 10px;
}

.close-btn {
  margin: 0 0 0 21px;
  cursor: pointer;

  @media screen and (max-width: $mobile-resolution) {
    width: 10%;
  }
}

.notification-transition-enter-active,
.notification-transition-leave-active {
  transition: all 0.5s;
}

.notification-transition-enter,
.notification-transition-leave-to {
  opacity: 0;
  max-height: 0;
}
</style>
